let viewId: string | undefined;

const mint = (): string =>
	typeof crypto !== "undefined" && "randomUUID" in crypto
		? crypto.randomUUID()
		: `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

/** One id per browser page load; client-side navigation keeps it, a new tab gets its own. */
export const getViewId = (): string | undefined => {
	if (typeof window === "undefined") return undefined;
	viewId ??= mint();
	return viewId;
};
